<template>
    <div class="vms-manager">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="语音群发" name="first">
                <el-table :data="vmsList" size="medium" height="60.4vh" v-loading="loading">
                    <el-table-column prop="name" label="语音" align="center" min-width="200px"></el-table-column>
                    <el-table-column prop="content" label="语音模板内容" align="center" min-width="1000px"> </el-table-column>
                    <el-table-column min-width="200px" prop="sent" label="发送状态" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.sent ? '已发送' : '未发送' }}
                        </template>
                    </el-table-column>
                    <el-table-column width="150px" fixed="right" label="操作" align="center">
                        <template slot-scope="scope">
							<!--  style="background: #409eff; border-color: #409eff; margin-bottom: 10px" -->
                            <el-button
                                size="medium"
                                type="text"
                               
                                @click="editVms(scope.row)"
                                >配置参数</el-button
                            >
							<!--  style="background: #de4d2a !important" -->
                            <el-button
                                size="medium"
                                type="text"
                                @click="wholeSend(scope.row)"
                                :loading="scope.row.btnLoading"
                                >全部发送</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="发送记录" name="second">
                <div class="meeting-search">
                    <el-form :inline="true" :model="recordForm" class="demo-form-inline">
                        <el-form-item label="语音模板">
                            <el-select v-model="recordForm.tmplCode" placeholder="语音模板" clearable>
                                <el-option label="全部" value=""></el-option>
                                <el-option
                                    v-for="(item, index) in vmsListArr"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.tmplCode"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="语音状态">
                            <el-select v-model="recordForm.sendResult" placeholder="语音状态" clearable>
                                <el-option label="全部" value=""></el-option>
                                <el-option label="发送中" value="WAIT"></el-option>
                                <el-option label="发送成功" value="SUCCESS"></el-option>
                                <el-option label="发送失败" value="FAIL"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="角色">
                            <el-select v-model="recordForm.roleType" placeholder="角色" clearable>
                                <el-option label="全部" value=""></el-option>
                                <el-option label="债权人" value="CREDITOR"></el-option>
                                <el-option label="管理人" value="MANAGER"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="姓名/手机号/账号">
                            <el-input style="width: 270px;" v-model.trim="recordForm.keyword" clearable placeholder="人名/手机号/账号"></el-input>
                        </el-form-item>
                        <el-form-item label="语音内容">
                            <el-input style="width: 270px;" v-model.trim="recordForm.content" clearable placeholder="语音内容搜索..."></el-input>
                        </el-form-item>
                        <el-form-item label="发送时间">
                            <el-date-picker
                                v-model="value"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item class="meeting-search-button">
							<!-- style="background: #de4d2a !important"  -->
                            <el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
                        </el-form-item>
						<div class="" style="float: right;">
							<el-form-item>
								<div class="flex align-center">
									<div class=""
										style="font-size: 14px;font-weight: 400;color: #FF5733;margin-right: 16px;">
										短信状态可能有延迟，可等5-10分钟后刷新
									</div>
									<el-button @click="onRefresh">刷新</el-button>
								</div>
							</el-form-item>
						</div>
						
                    </el-form>
                </div>
                <!-- <div class="refresh">
                    阿里云和供应商短信状态回执存在延迟，系统可能更新不及时，可稍等5-10分钟后刷新该页面<el-button
                        style="margin: 0 5px"
                        @click="onRefresh"
                        >刷新</el-button
                    >
                </div> -->
                <el-table
                    ref="multipleTable2"
                    @selection-change="handleSelectionChange"
                    :data="vmsList"
                    size="medium"
                    v-loading="loading"
                    height="41.8vh"
                    class="vms-table"
                >
                    <el-table-column type="selection" width="50"> </el-table-column>
                    <el-table-column prop="serialNumber" label="序号" align="center" width="50px"></el-table-column>
                    <el-table-column min-width="150px" label="姓名" align="center">
                        <template slot-scope="scope">
                            <el-button class="btn" type="text" @click="getPersonRecord(scope.row.userId)">{{ scope.row.name }}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150px" prop="toCode" label="手机号" align="center"> </el-table-column>
                    <el-table-column min-width="150px" prop="tmplName" label="语音名" align="center"> </el-table-column>
                    <el-table-column prop="contentDetail" label="语音内容" align="center">
                        <template slot-scope="scope">
                            <div :title="scope.row.contentDetail">
                                {{ scope.row.contentDetail }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150px" label="状态" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.sendResult === 'WAIT' ? '发送中' : scope.row.sendResult === 'SUCCESS' ? '发送成功' : '发送失败' }}
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150px" label="时间" align="center">
                        <template slot-scope="scope">
                            {{ timeFormat(scope.row.sendTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column width="150px" fixed="right" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" :loading="scope.row.btnLoading" @click.stop="againSend('single', scope.row)"
                                >重新发送</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <Pagination :total="total" @handleSizeChange="turnPage" @handleCurrentChange="turnPage" customClass="alone">
<!--                    <template v-slot:operation>
                        <div style="padding-left: 25px">
                            <el-button @click="toggleSelection('multipleTable2')" plain>取消选择</el-button>
                            <el-button
                                @click.stop="againSend('batch')"
                                :loading="batchLoading"
                                
                                type="primary"
                                >批量重发</el-button
                            >
                        </div>
                    </template> -->
                </Pagination>
            </el-tab-pane>
        </el-tabs>
        <el-dialog
            title="编辑语音参数"
            :close-on-click-modal="false"
            :visible.sync="centerDialogVisible"
            width="500px"
            center
            append-to-body
        >
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                <el-form-item label="会议名称" prop="meetingName" v-if="contentText.indexOf('meetingName') >= 0">
                    <el-input v-model="ruleForm.meetingName" placeholder="请输入会议名称, 且最多不能超过20字" :maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="联系管理人" prop="administrator" v-if="contentText.indexOf('administrator') >= 0">
                    <el-input v-model="ruleForm.administrator" placeholder="请输入管理人, 且最多不能超过20字" :maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="召开时间" prop="startTime" v-if="contentText.indexOf('startTime') >= 0">
                    <el-date-picker format="yyyy-MM-dd HH:mm" v-model="ruleForm.startTime" type="datetime" placeholder="选择召开时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="测试截止时间" prop="endTime" v-if="type === 'VMS_MEETING_TESTING'">
                    <el-date-picker format="yyyy-MM-dd HH:mm" v-model="ruleForm.endTime" type="datetime" placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
				<!-- style="background: #de4d2a !important" -->
				<el-button style="width: 120px;" @click="centerDialogVisible = false"
				    >取 消</el-button
				>
                <el-button style="width: 120px;" type="primary" :loading="editBtnLoading" @click="sureEditVms('ruleForm')"
                    >保 存</el-button
                >
            </span>
        </el-dialog>
        <el-dialog
            title="个人发送记录"
            :visible.sync="personDialogVisible"
            v-if="personDialogVisible"
            width="1060px"
            :center="false"
            append-to-body
            :close-on-click-modal="false"
            :before-close="closeDialog"
        >
            <!-- <el-card class="box-card"> -->
                <div class="meeting-search" style="padding: 20px">
                    <el-form :inline="true" :model="recordForm" class="demo-form-inline">
                        <el-form-item label="语音模板">
                            <el-select v-model="recordForm.tmplCode" placeholder="语音模板" clearable>
                                <el-option label="全部" value=""></el-option>
                                <el-option
                                    v-for="(item, index) in vmsListArr"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.tmplCode"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="语音状态">
                            <el-select v-model="recordForm.sendResult" placeholder="语音状态" clearable>
                                <el-option label="全部" value=""></el-option>
                                <el-option label="发送中" value="WAIT"></el-option>
                                <el-option label="发送成功" value="SUCCESS"></el-option>
                                <el-option label="发送失败" value="FAIL"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-select v-model="recordForm.phone" clearable>
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="(item, index) in phones" :key="index" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发送时间">
                            <el-date-picker
                                v-model="value"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item class="meeting-search-button">
                            <el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
                        </el-form-item>
						<div class="" style="float: right;">
							<el-form-item>
								<div class="flex align-center">
									<div class=""
										style="font-size: 14px;font-weight: 400;color: #FF5733;margin-right: 16px;">
										短信状态可能有延迟，可等5-10分钟后刷新
									</div>
									<el-button @click="onRefresh">刷新</el-button>
								</div>
							</el-form-item>
						</div>
                    </el-form>
                </div>
               <!-- <div class="refresh">
                    阿里云和供应商短信状态回执存在延迟，系统可能更新不及时，可稍等5-10分钟后刷新该页面<el-button
                        style="margin: 0 5px"
                        @click="onRefresh"
                        >刷新</el-button
                    >
                </div> -->
                <el-table
                    ref="multipleTable1"
                    @selection-change="handleSelectionChange"
                    :data="personVmsList"
                    size="medium"
                    v-loading="loading"
                    height="450px"
                >
                    <el-table-column type="selection" width="50"> </el-table-column>
                    <el-table-column prop="serialNumber" label="序号" align="center" width="50px"></el-table-column>
                    <el-table-column prop="name" label="姓名" align="center"> </el-table-column>
                    <el-table-column prop="toCode" label="手机号" align="center"> </el-table-column>
                    <el-table-column prop="tmplName" label="语音名" align="center"> </el-table-column>
                    <el-table-column label="状态" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.sendResult === 'WAIT' ? '发送中' : scope.row.sendResult === 'SUCCESS' ? '发送成功' : '发送失败' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="时间" align="center">
                        <template slot-scope="scope">
                            {{ timeFormat(scope.row.sendTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
							<!-- style="background: #de4d2a !important" -->
                            <el-button
                                type="text"
                                :loading="scope.row.btnLoading"
                                @click.stop="againSend('single', scope.row)"
                                >重新发送</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
                <Pagination :total="personalTotal" @handleSizeChange="turnPage" @handleCurrentChange="turnPage">
                   <template v-slot:operation>
                        <div style="padding-left: 25px">
                            <el-button @click="toggleSelection('multipleTable1')" plain style="border: 1rpx solid #2766FF;color: #2766FF;border-color:#2766FF;">取消选择</el-button>
							<!--  style="background: #de4d2a !important" -->
                            <el-button
                                @click.stop="againSend('batch')"
									style="border: 1rpx solid #2766FF;color: #2766FF;border-color:#2766FF;"
                                :loading="batchLoading"
                                >批量重发</el-button
                            >
                        </div>
                    </template>
                </Pagination>
            <!-- </el-card> -->
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog" type="primary">关 闭</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment';
import {
    getVmsList,
    groupVMS,
    getVmsRecordList,
    editVMS,
    againSend,
    getMeetingManager,
    getVmsListCount,
    getVmsRecordCount,
    getUserPhones
} from '@/serve/vms';
import Pagination from '@/components/Pagination';
export default {
    components: {
        Pagination
    },
    props: {
        isActiveName: String,
        meetingId: String,
        vmsTemplateList: Array,
        meetingData: Array
    },
    watch: {
        isActiveName(newVal, oldVal) {
            if (newVal === 'first') {
                this.getVmsList();
            }
        }
    },
    data() {
        return {
            batchLoading: false,
            personalTotal: 0,
            total: 0,
            ids: [],
            value: [],
            loading: false,
            btnLoading: false,
            editBtnLoading: false,
            activeName: 'first',
            vmsList: [],
            vmsListArr: [],
            multipleSelection: [],
            personVmsList: [],
            message: '',
            centerDialogVisible: false,
            personDialogVisible: false,
            phones: [],
            isPersonFlag: false,
            type: '',
            vmsRow: {},
            ruleForm: {
                administrator: '',
                meetingName: '',
                startTime: '',
                endTime: '',
                meeting: ''
            },
            contentText: '',
            managers: [],
            rules: {
                administrator: [{ required: true, message: '请输入管理人', trigger: 'blur' }],
                meetingName: [{ required: true, message: '请输入会议名称', trigger: 'blur' }],
                startTime: [{ required: true, message: '请选择召开时间', trigger: 'blur' }],
                endTime: [{ required: true, message: '请输入测试截止时间', trigger: 'blur' }],
                meeting: [{ required: true, message: '请输入参会地址', trigger: 'blur' }]
            },
            recordForm: {
                content: '',
                keyword: '',
                endTime: '',
                startTime: '',
                roleType: '',
                page: 0,
                rows: 20,
                lastSent: '',
                sendResult: '',
                tmplCode: '',
                username: '',
                userId: '',
                phone: ''
            }
        };
    },
    methods: {
        handleClick(tab) {
            this.getVmsList();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.ids = this.multipleSelection.map((item) => {
                return {
                    id: item.id
                };
            });
        },
        timeFormat(timescape) {
            return moment(timescape).format('YYYY-MM-DD HH:mm:ss');
        },
        // 翻页
        turnPage(attr, val) {
            this.recordForm[attr] = val;
            this.isPersonFlag ? this.getPersonVmsList() : this.getVmsList();
        },
        toggleSelection(val) {
            this.$refs[val].clearSelection();
        },
        // 重新发送
        againSend(type, row) {
            if (type === 'single') {
                row.btnLoading = true;
                this.ids = [{ id: row.id }];
            } else {
                if (!this.ids.length) {
                    return this.$message.warning('请先选择发送记录');
                }
                this.batchLoading = true;
            }
            againSend(this.meetingId, this.ids)
                .then(() => {
                    this.ids = [];
                    type === 'single' ? (row.btnLoading = false) : (this.batchLoading = false);
                    this.$message.success(type === 'single' ? '发送成功' : '批量发送成功');
                })
                .catch((err) => {
                    this.ids = [];
                    type === 'single' ? (row.btnLoading = false) : (this.batchLoading = false);

                    this.$message.error(err.data.message);
                });
        },
        // 搜索
        onSearch() {
			this.recordForm.page = 0;
            if (this.value && this.value.length) {
                this.recordForm.startTime = this.value[0].getTime();
                this.recordForm.endTime = this.value[1].getTime();
            }
            this.loading = true;
            this.isPersonFlag ? this.getPersonVmsList() : this.getVmsList();
        },
        onRefresh() {
            this.isPersonFlag ? this.getPersonVmsList() : this.getVmsList();
        },
        // 获取列表
        async getVmsList() {
            let arr;
            this.loading = true;
            if (this.activeName === 'first') {
                arr = await getVmsList(this.meetingId, { page: 0, rows: 100, type: 'VMS_TTS' });
                arr.forEach((item) => {
                    item.contentShow = item.content;
                    this.getExecStrs(item.content).forEach((citem) => {
                        while (item.content.includes(citem)) {
                            item.content = item.content.replace(citem, 'xxxx');
                        }
                    });
                });
            } else {
                this.recordForm.lastSent = true;
                this.recordForm.type = 'VMS_TTS';
                this.total = await getVmsRecordCount(this.meetingId, this.recordForm);
                this.vmsListArr = await getVmsList(this.meetingId, { page: 0, rows: 100, type: 'VMS_TTS' });
                if (this.total > 0) {
                    arr = await getVmsRecordList(this.meetingId, this.recordForm);
                } else {
                    this.loading = false;
                    return (this.vmsList = []);
                }
            }
            this.getList(arr);
        },
        // 列表处理
        getList(arr) {
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                item.serialNumber = i + 1;
                item.btnLoading = false;
                this.vmsTemplateList.forEach((citem) => {
                    if (citem.code === item.tmplCode) {
                        item.tmplName = citem.name;
                    }
                });
            }
            this.isPersonFlag ? (this.personVmsList = arr) : (this.vmsList = this.handleTableList(arr));
			
            this.loading = false;
        },
        // 重置筛选条件
        resetForm() {
            this.recordForm = {
                content: '',
                keyword: '',
                endTime: '',
                startTime: '',
                roleType: '',
                page: 0,
                rows: 20,
                lastSent: '',
                sendResult: '',
                tmplCode: '',
                username: '',
                userId: '',
                phone: ''
            };
        },
        closeDialog() {
            this.resetForm();
            this.personDialogVisible = this.isPersonFlag = false;
        },
        // 获取用户的所有手机号
        getUserPhones(userId) {
            getUserPhones(this.meetingId, { userId })
                .then((res) => {
                    this.phones = res;
                })
                .catch((err) => {
                    this.$message.error(err.data.message);
                });
        },
        // 获取个人详情记录
        getPersonRecord(id) {
            this.resetForm();
            this.loading = this.isPersonFlag = this.personDialogVisible = true;
            this.recordForm.lastSent = null;
            this.recordForm.userId = id;
            this.recordForm.type = 'VMS_TTS';
            this.getUserPhones(id);
            this.getPersonVmsList();
        },
        // 获取个人语音记录列表
        async getPersonVmsList() {
            this.personalTotal = await getVmsRecordCount(this.meetingId, this.recordForm);
            if (this.personalTotal > 0) {
                let personVmsList = await getVmsRecordList(this.meetingId, this.recordForm);
                this.getList(personVmsList);
            } else {
                this.loading = false;
                this.personVmsList = [];
            }
        },
        getExecStrs(str) {
            let reg = /\$\{.+?\}/g;
            let list = [];
            let result = null;
            do {
                result = reg.exec(str);
                result && list.push(result[0]);
            } while (result);
            return list;
        },
        // 获取会议管理人
        getMeetingManager() {
            getMeetingManager(this.meetingId)
                .then((res) => {
                    this.managers = [res];
                    this.ruleForm.administrator = res.name;
                    this.ruleForm.contactNumber = res.phone;
                })
                .catch((err) => {
                    this.$message.error(err.data.message);
                });
        },
        editVms(row) {
            this.vmsRow = row;
            this.type = row.tmplCode;
            this.contentText = row.contentShow;
			console.log("row.contentShow",row.contentShow)
            if (row.paramJson) {
                let paramJson = JSON.parse(row.paramJson);
                this.ruleForm.administrator = paramJson.administrator;
                this.ruleForm.meetingName = paramJson.meetingName;
                this.ruleForm.startTime = Date.parse(paramJson.startTime);
                this.ruleForm.endTime = Date.parse(paramJson.endTime);
            } else {
                this.getMeetingManager();
                this.ruleForm.meetingName = this.meetingData[0].name;
                this.ruleForm.startTime = this.meetingData[0].startTime;
                let date = new Date(this.meetingData[0].startTime - 24 * 60 * 60 * 1000);
                date.setHours(22);
                date.setMinutes(0);
                this.ruleForm.endTime = date.getTime();
            }
            this.centerDialogVisible = true;
        },
        // 全部发送
        wholeSend(row) {
            row.btnLoading = true;

            if (row.paramJson) {
                groupVMS(this.meetingId, row.id)
                    .then(() => {
                        row.btnLoading = false;
                        this.$message.success('发送成功');
                    })
                    .catch((err) => {
                        row.btnLoading = false;
                        this.$message.error(err.data.message);
                    });
            } else {
                this.editVms(row);
                this.$message.error('首次发送请确认参数');
                row.btnLoading = false;
            }
        },
        // 确认发送
        sureEditVms(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.editBtnLoading = true;
                    let ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
                    if (this.type === 'VMS_MEETING_TESTING') {
                        delete ruleForm.meeting;
                        ruleForm.startTime = moment(ruleForm.startTime).format('YYYY-MM-DD HH:mm');
                        ruleForm.endTime = moment(ruleForm.endTime).format('YYYY-MM-DD HH:mm');
                    } else {
                        delete ruleForm.endTime;
                        ruleForm.startTime = moment(ruleForm.startTime).format('YYYY-MM-DD HH:mm');
                    }
                    editVMS(this.meetingId, this.vmsRow.id, {
                        name: this.vmsRow.name,
                        tmplCode: this.vmsRow.tmplCode,
                        type: this.vmsRow.type,
                        paramJson: JSON.stringify(ruleForm)
                    })
                        .then(() => {
                            this.$message.success('保存成功');
                            this.getVmsList();
                            this.editBtnLoading = this.centerDialogVisible = false;
                        })
                        .catch((err) => {
                            this.editBtnLoading = false;
                            this.$message.error(err.data.message);
                        });
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
	::v-deep .el-table__fixed-right::before, .el-table__fixed::before{
		height: 0px;
	}
	::v-deep .el-range-editor--small .el-range-input{
		background-color: #F3F4F6;
	}
	::v-deep .meeting-search .el-input--small .el-input__inner{
		background-color: #F3F4F6;
		border: 0px;
	}
	::v-deep .meeting-search .el-range-editor--small.el-input__inner{
		background-color: #F3F4F6;
		border: 0px;
	}
.vms-manager {
    .meeting-search {
        padding: 0 10px;
        box-sizing: border-box;
    }
    .el-form-item {
        margin-right: 20px;
    }
    ::v-deep .el-tabs__nav-scroll {
        padding-left: 15px;
        box-sizing: border-box;
    }
    .refresh {
        color: red;
        font-size: 12px;
        // text-align: right;
        margin: 0 0 10px 10px;
    }
    .vms-table {
        ::v-deep .el-table__row {
            ::v-deep .cell {
                display: -webkit-box;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
            }
        }
        ::v-deep .is-leaf {
            // background: #c22929 !important;
            //  background: -webkit-linear-gradient(top, #cc0001 , #de4d2a, #f17b2e) !important;
            // background: -webkit-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
            // background: -moz-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
            // background: -o-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
            // background: -ms-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
            // background: linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
            // color: #fff;
            text-align: center;
        }
    }
    .el-table .el-button.btn {
        color: #2c7bbc;
        ::v-deep span:hover {
            border-bottom: 1px solid #2c7bbc;
        }
    }
}
</style>
